export default "__VITE_ASSET__D4r7m5S2__"